import React, { Component } from "react";
import { styles } from "../../../../../../ReactConst";
import { StyleRoot } from "radium";
import Close from "../../../../../../Icons/Close";
import Classnames from "classnames";
import _ from "lodash";
import { API } from "../../../../../../const";
import CameraComponent from "./CameraComponent";
import moment from "moment";
import { Service } from "../../../../../service/service";
import { withTranslation } from 'react-i18next';
class ModalOrdonnance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
      photo: null,
      ordonnanceList: [],
      oldOrdonnance: true,
      newOrdonnance: false,
      inputText: "",
      ordonnancePhoto: null,
      inputText: "",
      openCamera: false,
      OrdonnanceName: "",
      checkedValues: "",
      errorOrd: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.bytesToSize = this.bytesToSize.bind(this);
    this.capturedOrdonnance = this.capturedOrdonnance.bind(this);
    this.handleChangeOrdance = this.handleChangeOrdance.bind(this);
    this.submitOrdonnance = this.submitOrdonnance.bind(this);
    this.handleCheckKids = this.handleCheckKids.bind(this);
  }

  handleCheckKids(event) {
    if (this.state.checkedValues == event.currentTarget.value) {
      this.setState({
        checkedValues: "",
      });
    } else {
      this.setState({
        checkedValues: event.currentTarget.value,
      });
    }
  }

  submitOrdonnance = (event) => {
    event.preventDefault();
    if (
      this.state.newOrdonnance === true &&
      !_.isEmpty(this.state.OrdonnanceName)
    ) {
      let tok = localStorage.getItem("token");
      var kidsId = this.props.kidItem.id;
      let formPayload = new FormData();
      formPayload.append("file", this.state.ordonnancePhoto);
      const response = Service.post(
        `${API}api/creche/files?category=ORDONNANCE`,
        formPayload,
        {
          headers: { Authorization: `Bearer ${tok}` },
        }
      );
      response.then((res) => {
        var data = {};
        data.idFichier = res.data.files[0].fileId;
        data.titre = this.state.OrdonnanceName;
        const response = Service.post(
          `${API}api/enfant/creche/enfants/${kidsId}/dossier-medical/ordonnances`,
          data,
          { headers: { Authorization: `Bearer ${tok}` } }
        );
        response.then((res) => {
          this.props.updateTreatement(res.data.id, true);
        });
        response.catch((err) => {
          console.log("err", err);
        });
      });
      response.catch((err) => {
        console.log("err", err);
      });
    } else if (
      this.state.oldOrdonnance &&
      _.isNumber(this.state.checkedValues) &&
      this.props.traitementItem.idOrdonnance === this.state.checkedValues
    ) {
      this.props.updateTreatement(this.state.checkedValues, false);
    } else if (
      this.state.oldOrdonnance &&
      _.isNumber(this.state.checkedValues) &&
      this.props.traitementItem.idOrdonnance !== this.state.checkedValues
    ) {
      this.props.updateTreatement(this.state.checkedValues, true);
    } else if (_.isEmpty(this.state.OrdonnanceName)) {
      this.setState({ errorOrd: this.props.t('modal_enfant.ordonnance_tab.field_required') });
    } else {
    }
  };

  handleChangeOrdance = (name) => (event) => {
    this.setState({ errorOrd: "", [name]: event.target.value });
  };

  capturedOrdonnance = (photo) => {
    this.setState({
      ordonnancePhoto: photo,
      openCamera: false,
      newOrdonnance: true,
      inputText: photo.name,
    });
  };

  onCloseModaleCamera = () => {
    this.setState({
      openCamera: false,
      oldOrdonnance: true,
      newOrdonnance: false,
      errorOrd: "",
    });
  };

  handleChange = (event) => {
    event.preventDefault();
    if (event.target.name === "oldOrdonnance") {
      this.setState({
        oldOrdonnance: true,
        newOrdonnance: false,
        errorOrd: "",
      });
    }
    if (event.target.name === "newOrdonnance") {
      this.setState({
        oldOrdonnance: false,
        newOrdonnance: true,
        errorOrd: "",
      });
    }
  };

  componentDidMount() {
    this.setState({
      styleFadeIn: true,
      ordonnanceList: this.props.ordonnanceList,
      checkedValues: this.props.traitementItem.idOrdonnance,
    });
  }

  closeModal = (event) => {
    event.preventDefault();
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.handleCloseDelete();
    }, 400);
  };

  bytesToSize(bytes) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "n/a";
    const i = parseInt(
      Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)),
      10
    );
    if (i === 0) return `${bytes} ${sizes[i]})`;
    return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
  }

  openCameraComponent = () => {
    this.setState({
      openCamera: true,
      oldOrdonnance: false,
    });
  };

  render() {
    const { errorOrd } = this.state;
    const { t } = this.props;
    return (
      <StyleRoot>
        <div
          className="modal modal-skin show actif"
          id="modalOrdonnance"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div
            className="modal-dialog modal-dialog-centered modal-bg"
            role="document"
          >
            <div className="modal-content">
              <form>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close
                    className="img-fluid"
                    alt=""
                    onClick={this.closeModal}
                  />
                </button>
                <div className="modal-body fiche-enfant">
                  <h5 className="modal-title mb-5">{t('modal_enfant.ordonnance_tab.associate')}</h5>
                  <p className="bottom-space" />
                  <section className="content-section">
                    <div className="row justify-content-center mb-3">
                      <div className="col-md-4 ">
                        <input
                          onChange={this.handleChange}
                          type="checkbox"
                          className="d-none"
                          id="oldOrdonnance"
                          value={this.state.oldOrdonnance}
                          name="oldOrdonnance"
                        />
                        <label
                          htmlFor="oldOrdonnance"
                          className={Classnames("btn-white btn-border", {
                            active: this.state.oldOrdonnance === true,
                          })}
                        >
                          {t('modal_enfant.ordonnance_tab.existing')}
                        </label>
                      </div>
                      <div className="col-md-4">
                        <input
                          id="files"
                          type="button"
                          className="d-none"
                          onClick={this.openCameraComponent}
                        />
                        <label
                          htmlFor="files"
                          className={Classnames("btn-white btn-border", {
                            active: this.state.newOrdonnance === true,
                          })}
                        >
                          <strong>{t('modal_enfant.ordonnance_tab.new')}</strong>
                        </label>
                      </div>
                    </div>
                  </section>
                  {this.state.oldOrdonnance === true ? (
                    <section className="content-section">
                      {this.props.ordonnanceList.length > 0 ? (
                        <ul className="row mx-n2 list-enfants list-sans-avatar mb-0">
                          {this.props.ordonnanceList.map((element, index) => (
                            <li
                              className="col-md-6 mb-3 px-2"
                              onClick={this.handleCheckKids}
                              value={element.id}
                            >
                              <input
                                type="checkbox"
                                id="ordonnance5"
                                defaultValue="recupere5"
                                checked={
                                  element.id == this.state.checkedValues
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="rounded15 box-shadow"
                                htmlFor="recupere5"
                              >
                                <span className="avatar" />
                                <span className="name">
                                  {element.titre} du{" "}
                                  {moment(this.props.traitementItem).format(
                                    "DD/MM/YYYY"
                                  )}
                                </span>
                              </label>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        ""
                      )}
                    </section>
                  ) : (
                    <section className="content-section">
                      <div className="list-medias pt-1">
                        <div
                          className="item-media row mx-0 d-flex align-items-center"
                          style={{ borderBottom: "none" }}
                        >
                          <div
                            style={errorOrd ? { marginBottom: "45px" } : {}}
                            className="col-md-5 px-0 d-flex align-items-center"
                          >
                            <div className="img-media-post">
                              <img
                                src={
                                  this.state.ordonnancePhoto !== null
                                    ? URL.createObjectURL(
                                        this.state.ordonnancePhoto
                                      )
                                    : "https://via.placeholder.com/100"
                                }
                                className="img-fluid"
                              />
                            </div>
                            <div className="infos-media-post">
                              <p>{this.state.inputText}</p>
                              <p className="text-grey">
                                {this.state.ordonnancePhoto !== null
                                  ? this.bytesToSize(
                                      this.state.ordonnancePhoto.size
                                    )
                                  : " 0 ko"}
                              </p>
                            </div>
                          </div>
                          <div className="col-md-7">
                            <div
                              className={Classnames("form-group", {
                                "error-mess": !_.isEmpty(errorOrd),
                              })}
                            >
                              <input
                                type="text"
                                className="form-control"
                                placeholder={t('modal_enfant.ordonnance_tab.name_placeholder')}
                                style={{ paddingLeft: 20 }}
                                name="OrdonnanceName"
                                value={this.state.OrdonnanceName || ""}
                                onChange={this.handleChangeOrdance(
                                  "OrdonnanceName"
                                )}
                              />
                              {errorOrd ? <p>{errorOrd}</p> : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )}
                  <section className="content-section">
                    <div className="d-flex justify-content-center">
                      <div className="row align-items-center md-5">
                        <div className="col-md-6">
                          <button
                            className="btn-white btn-border btn-valid"
                            data-dismiss="modal"
                            onClick={(e) => this.closeModal(e)}
                          >
                            {t('common.cancel')}
                          </button>
                        </div>
                        <div className="col-md-6">
                          <button
                            type="submit"
                            className="btn-gradient btn-valid margin-left"
                            data-dismiss="modal"
                            onClick={this.submitOrdonnance}
                          >
                            {" "}
                            {t('modal_enfant.ordonnance_tab.use')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </form>
            </div>
          </div>
          {this.state.openCamera === true ? (
            <CameraComponent
              onCloseModaleCamera={this.onCloseModaleCamera}
              capturedOrdonnance={this.capturedOrdonnance}
            />
          ) : (
            ""
          )}
        </div>
      </StyleRoot>
    );
  }
}

export default withTranslation()(ModalOrdonnance);
